import { css, keyframes } from 'styled-components';
export let SkeletonHeight = /*#__PURE__*/function (SkeletonHeight) {
  SkeletonHeight["BIG"] = "3rem";
  SkeletonHeight["LARGE"] = "1.5rem";
  SkeletonHeight["MEDIUM"] = "1rem";
  SkeletonHeight["SMALL"] = "0.5rem";
  return SkeletonHeight;
}({});
export let SkeletonColor = /*#__PURE__*/function (SkeletonColor) {
  SkeletonColor["LIGHT"] = "LIGHT";
  SkeletonColor["DARK"] = "DARK";
  return SkeletonColor;
}({});
const skeletonKeyframes = keyframes(["from{background-position-x:-200px;}to{background-position-x:calc(200px + 100%);}"]);
export const base = _ref => {
  let {
    $lineHeight
  } = _ref;
  return css(["line-height:", ";flex-basis:100%;"], $lineHeight === undefined ? 'inherit' : $lineHeight);
};
export const skeleton = _ref2 => {
  let {
    $width,
    $height,
    $circle,
    $colorVariant
  } = _ref2;
  const colors = {
    [SkeletonColor.LIGHT]: {
      base: '#eee',
      light: '#f5f5f5'
    },
    [SkeletonColor.DARK]: {
      base: '#e2e2e2',
      light: '#f0f0f0'
    }
  };
  const selectedColors = colors[$colorVariant];
  return css(["background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;animation:", " 1.2s ease-in-out infinite;", " ", " ", ""], selectedColors.base, selectedColors.base, selectedColors.light, selectedColors.base, skeletonKeyframes, $width && `
      width: ${$width};
    `, $height && `
      height: ${$height};
    `, ($width || $height) && $circle && `
      border-radius: 50%;
    `);
};
//# sourceMappingURL=Skeleton.style.js.map